import {
  Draft,
  CButton,
  CImage,
  Divider,
  CForm,
  Icon,
  CVideo,
  BrandLogo,
  CodeSnippet,
  CountdownTimer,
} from '../../../../lib/helper-classes'
import { CCard } from '../../../../lib/custom-component-descriptors/ccard'
import { CContainer } from '../../../../lib/custom-component-descriptors/ccontainer'

export const dragItems = [
  {
    icon: 'far fa-pen',
    name: 'text',
    label: 'Text',
    type: 'Text',
    id: 'text_element',
    tag: 'draft',
    elementType: Draft,
    options: {
      desktop: {
        width: '130px',
        flexGrow: 1,
      },
      phone: {
        width: '100%',
      },
    },
  },
  {
    icon: 'fal fa-hand-pointer',
    name: 'button',
    label: 'Button',
    type: 'Button',
    id: 'button_element',
    tag: 'c-button',
    elementType: CButton,
    options: {},
  },
  {
    icon: 'cvt-icon-picture-text',
    name: 'image',
    label: 'Image',
    type: 'Image',
    id: 'image_element',
    tag: 'c-image',
    elementType: CImage,
    options: {
      desktop: {
        width: '50%',
      },
      phone: {
        width: '100%',
      },
    },
  },
  {
    icon: 'cvt-icon-video',
    name: 'video',
    label: 'Video',
    type: 'Video',
    id: 'video_element',
    tag: 'c-video',
    elementType: CVideo,
    options: {
      desktop: {
        width: '200px',
      },
      phone: {
        width: '100%',
      },
    },
  },
  {
    icon: 'cvt-icon-minus',
    name: 'divider',
    label: 'Divider',
    type: 'Divider',
    id: 'divider_element',
    tag: 'divider',
    elementType: Divider,
    options: {
      desktop: {
        width: '100%',
      },
      phone: {
        width: '100%',
      },
    },
  },
  {
    icon: 'cvt-icon-logo',
    name: 'logo',
    label: 'Logo',
    type: 'Logo',
    id: 'logo_element',
    tag: 'brand-logo',
    elementType: BrandLogo,
    options: {
      desktop: {
        width: '100%',
      },
      phone: {
        width: '100%',
      },
    },
  },
  {
    icon: 'cvt-icon-star',
    name: 'icon',
    label: 'Icon',
    type: 'Icon',
    id: 'icon_element',
    tag: 'icon',
    elementType: Icon,
    options: {},
  },
  {
    icon: 'cvt-icon-layout-three-rows',
    name: 'form',
    label: 'Form',
    type: 'Form',
    id: 'form_element',
    tag: 'c-form',
    elementType: CForm,
    options: {},
  },
  {
    icon: 'cvt-icon-code',
    name: 'code',
    label: 'Code',
    type: 'Code',
    id: 'code_element',
    tag: 'code-snippet',
    elementType: CodeSnippet,
    options: {},
  },
  {
    icon: 'fal fa-stopwatch',
    name: 'countdown_timer',
    label: 'Countdown Timer',
    type: 'Countdown Timer',
    id: 'countdown_timer_element',
    tag: 'countdown-timer',
    elementType: CountdownTimer,
    options: {},
  },
  {
    icon: 'cvt-icon-bullet-list',
    name: 'card_element',
    label: 'Bullet List',
    type: 'Bullet List',
    id: 'card_element',
    tag: 'c-card',
    elementType: CCard,
    options: {},
  },
  // {
  //   icon: 'fal fa-puzzle-piece',
  //   name: 'custom_widget',
  //   label: 'Custom Widget',
  //   type: 'Custom Widget',
  //   id: 'custom_widget_element',
  //   tag: 'c-custom-widget',
  //   elementType: CustomWidget,
  // },
  {
    icon: 'cvt-icon-four-squares-broken-line',
    name: 'container',
    label: 'Container',
    type: 'Container',
    id: 'ccontainer_element',
    tag: 'c-container',
    elementType: CContainer,
    options: {
      desktop: {
        flexGrow: 1,
      },
      phone: {
        width: '100%',
      }
    },
  },
]

export function findDragItemByTag(tag: string): any {
  return dragItems.find((item) => item.tag === tag)
}

export function findDragItemById(id: string) {
  return dragItems.find((item) => item.id === id)
}
